import type { Content } from "@/react/story/types";

type Props = {
    content: Content;
}

export default function ContentAudio(props: Props) {
    const value = props.content.config.src;
    const src = "string" === typeof value ? value : value?.uri ?? null;
    if (null === src) {
        return null;
    }

    return (
        <audio
            style={{ zIndex: 1000 }}
            src={src}
            controls
        />
    );
}
